<div class="list-group-item list-group-item-action">
  <div class="clickable">
    <span class="fa" [ngClass]="{'fa-chevron-left': node.isCompetency, 'fa-folder-o': !node.isCompetency}"></span>&nbsp;
    <span (click)="onNodeClicked(node)">{{node.name}}</span>
  </div>
  @if (node.children && node.children.length && node.isExpanded) {
    <div class="list-group">
      @for (child of node.children; track child) {
        <competency-node [node]="child" (onCompetencyClicked)="onChildNodeClicked($event)"></competency-node>
      }
    </div>
  }
</div>
